import { defineComponent as _defineComponent } from 'vue'
import {
        computed,
    } from 'vue';
    import { THotelCardRightBlock } from '@ve/components/serpHotelCard/types';
    import ButtonV from '@ve/components/button/desktop/Button.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPageHotelCardRightBlockRedirectButton',
  props: {
    productType: null
  },
  setup(__props: any) {

const props = __props as { productType: THotelCardRightBlock['productType'] };

    

    const showToursButtonText = computed(() => (
        props.productType === 'hotelOffer' ? 'Показать номера' : 'Показать туры'
    ));

return { __sfc: true,props, showToursButtonText, ButtonV }
}

})